var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useEffect, useReducer, } from "react";
import { setAllDocuments, setMainConfig } from "./actions";
import { initialState, mainStateReducer, } from "./reducer";
var DocViewerContext = createContext({ state: initialState, dispatch: function () { return null; } });
var AppProvider = function (props) {
    var children = props.children, documents = props.documents, config = props.config, pluginRenderers = props.pluginRenderers;
    var _a = useReducer(mainStateReducer, __assign(__assign({}, initialState), { documents: documents || [], currentDocument: documents && documents.length ? documents[0] : undefined, config: config, pluginRenderers: pluginRenderers })), state = _a[0], dispatch = _a[1];
    // On inital load, and whenever they change,
    // replace documents with the new props passed in
    useEffect(function () {
        dispatch(setAllDocuments(documents));
        config && dispatch(setMainConfig(config));
    }, [documents]);
    return (React.createElement(DocViewerContext.Provider, { value: { state: state, dispatch: dispatch } }, children));
};
export { DocViewerContext, AppProvider };
